





















































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { subnetMap, VMMap, VMDocumentationMap, VMFullNameMap } from '@/helper'
import Blockchain from '@/js/Blockchain'
import Indexed from '@/components/Blockchain/Indexed.vue'
import { getTxChainType } from '@/known_blockchains'
import { P, X, C } from '@/known_blockchains'

@Component({
    components: {
        Indexed,
    },
})
export default class BlockchainDataTable extends Vue {
    @Prop() blockchains!: Blockchain[]
    @Prop() links?: boolean
    @Prop() subnets?: boolean
    @Prop() title?: string

    get headers(): any[] {
        const headers = [
            { text: 'Name', value: 'name', width: 200, fixed: true },
            { text: 'VM', value: 'vmID', width: 125 },
            { text: 'Subnet', value: 'subnetID', width: 300 },
            { text: 'Index', value: 'indexed', width: 125 },
        ]
        return this.subnets ? headers : headers.slice(0, 5)
    }

    chainDarkColor(id: string) {
        switch (id) {
            case P.id:
                return getTxChainType(id)!.darkColor
            case X.id:
                return getTxChainType(id)!.darkColor
            case C.id:
                return getTxChainType(id)!.darkColor
            default:
                return '#FFF'
        }
    }

    chainCode(id: string) {
        switch (id) {
            case P.id:
                return getTxChainType(id)!.code
            case X.id:
                return getTxChainType(id)!.code
            case C.id:
                return getTxChainType(id)!.code
            default:
                return ''
        }
    }

    subnet(val: string) {
        return subnetMap(val)
    }

    vm(val: string) {
        return VMMap(val)
    }

    vmDocumentation(val: string) {
        return VMDocumentationMap(val)
    }

    vmFullName(val: string) {
        return VMFullNameMap(val)
    }
}
